import React, { Component } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';

class ProductSpecs extends Component{

  render(){
    const { product } = this.props;
    let specifications = [];
    if (product) {
      specifications = product.productspecifications;
    }
    specifications = specifications.sort((a, b) => {
      const array_a = a.name.split('-');
      const array_b = b.name.split('-');
      return array_a[array_a.length-1] - array_b[array_b.length-1];
    });
    return (
      <table className="product-specs table">
        <tbody>
          {specifications.map((elem, idx) => {
            return <tr key={`spec-${idx}`}>
              <td className="spec-title">{elem.title}</td>
              <td className="spec-description" dangerouslySetInnerHTML={{ __html: marked(elem.description) }}></td>
            </tr>
          })}
        </tbody>
      </table>
    );
  }
}

ProductSpecs.propTypes = {
  product: PropTypes.shape({
    productspecifications: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default ProductSpecs;




// WEBPACK FOOTER //
// ./src/components/ProductSpecs.js